import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import Clear from "@material-ui/icons/Clear";
import { focusRingIconButton, focusRingLink } from "@passportinc/hydra-core";
import DynamicString from "@passportinc/hydra-core/components/DynamicString";
import { numberFormat } from "@passportinc/hydra-core/utils/common";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

export const styles = (theme) => ({
	root: {
		width: "100%",
		borderRadius: 2,
		border: "solid 1px #bcc8ce",
		padding: "15px 10px 10px 15px",
		marginBottom: 16,
		position: "relative",
	},
	actionContainer: {
		top: "0",
		right: "0",
		width: 42,
		height: 42,
		position: "absolute",
	},
	closeIconButton: {
		top: 2,
		right: 2,
		width: 42,
		height: 42,
		fontWeight: 700,
		color: theme.palette.primary.main,
		...focusRingIconButton(theme),
	},
	title: {
		color: theme.palette.primary.main,
		width: "100%",
		fontSize: "0.875rem",
		fontWeight: "bold",
		marginBottom: 4,
	},
	text: {
		width: "100%",
		fontSize: "0.75rem",
		fontWeight: "normal",
		lineHeight: "1.8",
		color: theme.palette.text.accessible,
		marginBottom: 4,
	},
	subtitleText: {
		fontSize: "0.75rem",
		fontWeight: "normal",
		lineHeight: "1.8",
		color: theme.palette.secondary.main,
		marginBottom: 4,
	},
	edit: {
		fontSize: "0.75rem",
		fontWeight: "bold",
		lineHeight: "1.8",
		color: theme.palette.primary.main,
		marginBottom: 4,
		marginLeft: "1rem",
		textDecoration: "none",
		...focusRingLink(theme),
	},
	value: {
		width: "100%",
		fontSize: "0.75rem",
		fontWeight: "bold",
		lineHeight: "1.8",
		color: theme.palette.secondary.main,
		marginLeft: "auto",
		textAlign: "right",
		flex: 1,
	},
	closeIconStyle: {
		width: 24,
		height: 24,
		marginTop: -3,
	},
	bottomRow: {
		display: "flex",
	},
});

/**
 * CartItem React Component
 * @returns {React.Component} CartItem component
 */
class CartItem extends React.Component {
	/**
	 * @param {Integer} value The major currency value. Ex: in Dollars.
	 * @returns {String} formatted currency string.
	 */
	format = (value) => numberFormat(value, { style: "currency" });

	/**
	 * @inheritDoc
	 */
	render() {
		const { item, title, text, subtitle, value, onRemoveItem, onClose, isWaitlisted } = this.props;
		const { classes } = this.props;

		return (
			<div id={item.id} className={classes.root}>
				{!isWaitlisted && (
					<div className={classes.actionContainer}>
						<IconButton className={classes.closeIconButton} onClick={onRemoveItem} aria-label="Remove item">
							<Clear className={classes.closeIconStyle} />
						</IconButton>
					</div>
				)}
				<div>
					<div className={classes.title}>{title}</div>
					<div className={classes.text}>{text}</div>
					<div className={classes.bottomRow}>
						{subtitle && <div className={classes.subtitleText}>{subtitle}</div>}
						{item.quantity && (
							<Link to={`/permits/manage/${item.id}/manage-passes?add=true`} onClick={onClose} className={classes.edit}>
								Edit
							</Link>
						)}
						<div className={classes.value}>{this.format(value)}</div>
					</div>
				</div>
			</div>
		);
	}
}

CartItem.defaultProps = {
	title: DynamicString.resolve("hydra_permits_card_item_title", "Title"),
	text: DynamicString.resolve("hydra_permits_card_item_text", ""),
	subtitle: DynamicString.resolve("hydra_permits_card_item_subtitle", ""),
	value: 0,
	isWaitlisted: false,
};

CartItem.propTypes = {
	item: PropTypes.shape({}).isRequired,
	classes: PropTypes.shape({}).isRequired,
	title: PropTypes.string,
	text: PropTypes.string,
	subtitle: PropTypes.string,
	value: PropTypes.number,
	onRemoveItem: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	isWaitlisted: PropTypes.bool,
};

export default withStyles(styles)(CartItem);
